



































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import {
	columnCurrencyFormatter,
	columnDateFormatter,
	columnDateTimeFormatter,
} from "@/utils/CommonUtils";
import Grid from "@/grid/Grid.vue";
import Button from "@/form/Button.vue";
import LeftRightFooter from "@/components/LeftRightFooter.vue";
import { Batch } from "@/models/FinalBatchReviewRecord";
import ErrorList from "@/components/ErrorList.vue";

@Component({
	components: {
		ErrorList,
		Modal,
		Grid,
		Button,
		LeftRightFooter,
	},
})
export default class ReviewAuthorisedUnfundedBatches extends Vue {
	@Prop({ default: [] })
	private authorisedUnfundedBatches: Batch[] | undefined;

	private columnDefs = [
		{
			headerName: "Batch ID",
			field: "batchId",
			resizable: true,
		},
		{
			headerName: "Pay period start date",
			field: "payPeriodStartDate",
			resizable: true,
			valueFormatter: columnDateFormatter,
		},
		{
			headerName: "Pay period end date",
			field: "payPeriodEndDate",
			resizable: true,
			valueFormatter: columnDateFormatter,
		},
		{
			headerName: "Total amount",
			field: "totalAmount",
			resizable: true,
			valueFormatter: columnCurrencyFormatter,
		},
		{
			headerName: "Date created",
			field: "dateCreated",
			resizable: true,
			valueFormatter: columnDateFormatter,
		},
		{
			headerName: "Date authorised",
			field: "dateAuthorised",
			resizable: true,
			valueFormatter: columnDateTimeFormatter,
			width: 240,
		},
		{
			headerName: "Order of payment",
			field: "orderOfPayment",
			resizable: true,
		},
	];

	onClickCancel() {
		this.$emit("close");
	}

	onClickAuthorise() {
		this.$emit("approve");
	}
}
